// @core/api/endpoints/resource/list_resource_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListResourceTypesResponse,
} from '../../../types/resource';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/resource';

/**
 * List resource types
 * Returns all registered resource types in the system. Can be filtered by product to show only types relevant to a specific product.
 */
export async function ListResourceTypes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListResourceTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/types`;
  const requestOptions = options;
  return client.get<ListResourceTypesResponse>(requestPath, { ...requestOptions, params });
}
